<script lang="ts">
    export let value: number
    export let initial: number = 0
    export let step: number = 1

    let result: number = initial
    $: result = initial

    setInterval(() => {
        if (result > value) {
            result -= step
        } else if(result < value) {
            result += step
        }
    }, 50)
</script>

<span>{result}</span>